import { ModalBottom } from "../ModalBottom";
import { ReactComponent as IconCamera } from "../../../styles/assets/svg/icon_fileCamera.svg";
import { ReactComponent as IconGallery } from "../../../styles/assets/svg/icon_gallery.svg";

interface ModalDietProps {
  setOpen: (e: any) => void;
  titleText: any;
  setModalRef: (e: any) => void;
  setCapMode: (e: any) => void;
}

export const ModalDietFile = ({
  setOpen,
  titleText,
  setModalRef,
  setCapMode,
}: ModalDietProps) => {
  return (
    <ModalBottom
      title="사진은 어떻게 가져올까요?"
      onClose={() => setOpen(false)}
      onRow={false}
    >
      <div
        style={{
          padding: "0 0 8px",
          display: "flex",
          gap: 16,
        }}
      >
        <div
          style={{
            width: "100%",
            height: 56,
            padding: 16,
            background: "var(--neutral-50, #FAFAFA)",
            borderRadius: 16,
            outline: "1px var(--neutral-200, #E5E5E5) solid",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
          onClick={() => {
            setModalRef(true);
            setCapMode(false);
          }}
        >
          <IconGallery />
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div style={{ ...titleText, color: "var(--neutral-600, #525252)" }}>
              갤러리
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            padding: 16,
            borderRadius: 16,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            background: "linear-gradient(180deg, #FFA040 0%, #F57C00 100%)",
            cursor: "pointer",
          }}
          onClick={() => {
            setModalRef(true);
            setCapMode(true);
          }}
        >
          <IconCamera />
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 4,
              }}
            >
              <div
                style={{ ...titleText, color: "var(--neutral-50, #FAFAFA)" }}
              >
                카메라
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBottom>
  );
};
